export default {
  rowActions: {
    actions: "Acciones",
  },
};
